import React, { useState, useContext } from "react";
import "../collect/collect.css";
import moment from "moment";
import Swal from "sweetalert2";
import Navbar from "../../shared/Navbar";
import { AuthContext } from "../../ContextApi/ContextApi";
import { useNavigate } from "react-router-dom";  // 👈 MUST ADD
import { ADD_NEW_ACCOUNT_URL, GET_NEW_ACCOUNTS_URL } from "../../api/apiurls";
export default function AddAccount() {

  const { userName: agentUserName, firstName } = useContext(AuthContext); // 👈 now firstName exists
  const navigation = useNavigate(); // 👈 now navigation exists

  const [accountNo, setAccountNo] = useState("");
  const [name, setName] = useState("");
  const [received, setReceived] = useState("");
  const [accountType] = useState("PIGMY");
  const [openDate] = useState(moment().format("DD.MM.YY"));

  const [savedView, setSavedView] = useState(false);
  const [savedBalance, setSavedBalance] = useState("");


  // ==================== PRINT RECEIPT =====================
  const printReceipt = () => {
    navigation("/BluetoothTest", {
      state: {
        firstName,
        Name: name,
        AccountNo: accountNo,
        AccountType: accountType,
        Recieved: received,
        PresentBalance: received,   // no extra balance so use same
        Phone: "",
        agentUserName
      }
    });
  };

  // ==================== SAVE ACCOUNT =====================
  const saveData = async () => {
  if (!agentUserName) {
    Swal.fire("Session Error", "Please log in again before adding an account.", "error");
    return;
  }

  if (!name.trim() || !received) {
    Swal.fire("Missing Fields", "Enter Name & Received Amount", "error");
    return;
  }

  const payload = {
    AgentName: agentUserName,
    Name: name.trim(),
    Recieved: Number(received),
  };

  try {
    // 🔹 SAVE ACCOUNT
    const res = await fetch(ADD_NEW_ACCOUNT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const errorBody = await res.json().catch(() => null);
      const message = errorBody?.error || errorBody?.detail || "Could not save account.";
      Swal.fire("Error", message, "error");
      return;
    }

    Swal.fire("Success!", "Account Created Successfully", "success");

    // 🔹 FETCH LATEST ACCOUNT
    const getRes = await fetch(GET_NEW_ACCOUNTS_URL);
    if (!getRes.ok) throw new Error("Failed to fetch latest account");

    const list = await getRes.json();
    const latest = list[list.length - 1]; // newest record

    setAccountNo(latest?.AccountNo ?? "NOT FOUND");
    setSavedBalance(latest?.Recieved ?? received);
    setSavedView(true);

  } catch (err) {
    console.error(err);
    Swal.fire("Server Error", "Connection failed", "error");
  }
};



  // ==================== SUMMARY SCREEN =====================
  if (savedView) {
    return (
      <div>
        <Navbar />

        <div className="Collect-container">
          <h2 className="Collect-title">Account Created</h2>

          <input className="Collect-input" readOnly value={accountNo} />
          <input className="Collect-input" readOnly value={name} />
          <input className="Collect-input" readOnly value={`₹${savedBalance}`} />

          <div className="Collect-btn-row">
            <button className="Collect-btn" >SMS</button>
            <button className="Collect-btn"  onClick={printReceipt}>PRINT</button>
            <button className="Collect-btn Collect-btn-clear" onClick={()=>window.location.reload()}>Clear</button>
          </div>
        </div>
      </div>
    );
  }


  // ==================== ADD ACCOUNT FORM =====================
  return (
    <div>
      <Navbar />
      <div className="Collect-container">
        <h2 className="Collect-title">Add New Account</h2>

<input className="Collect-input" value={accountNo} style={{ display: "none" }} />
        <input className="Collect-input" value={name} onChange={(e)=>setName(e.target.value)} placeholder="Name" />
        <input className="Collect-input" value={accountType} readOnly />
        <input className="Collect-input" value={openDate} readOnly />
        <input className="Collect-input" value={received} onChange={(e)=>setReceived(e.target.value)} placeholder="Received Amount" />

        <div className="Collect-btn-row">
          <button className="Collect-btn Collect-btn-clear" onClick={()=>window.location.reload()}>Clear</button>
          <button className="Collect-btn Collect-btn-save" onClick={saveData}>Save</button>
        </div>
      </div>
    </div>
  );
}
